import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { getHotManga } from '@/mocks/manga';

export default function HotRecommend() {
  const hotManga = getHotManga();

  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">千万读者都在追的精选<strong>韩国漫画</strong></p>
        </div>
        <Link
          to="/category/korean-romance"
          className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
        {hotManga.map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>
    </section>
  );
}